import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {RuleMessageDTO} from '../models/RuleMessageDTO';

@Injectable({
  providedIn: 'root'
})
export class RuleMessageService {
  private url = environment.baseClmUrl + '/rule-message';

  constructor(private httpClient: HttpClient) {
  }

  saveRuleMessageList(ruleMessageDTO: RuleMessageDTO[]): Observable<RuleMessageDTO[]> {
    return this.httpClient.post<RuleMessageDTO[]>(this.url + '/list', ruleMessageDTO);
  }
}
